<h3 class="mt-5">Modificar documentos</h3>

<app-document-table
  [documents]="documents"
  [requirementId]="requirementId"
  [driverMdmid]="driverMdmid"
  [assetId]="assetId"
  [driverIsEmployee]="driverIsEmployee"
  [shouldShowDocumentLinks]="true"
  [shouldEditEffectiveDate]="true"
  [editableDocuments]="false"
  [formArray]="documentFormArray"
  [marginTop]="false"
>
</app-document-table>

<div class="u-mt50">
  <div class="request__send u-bt u-bt--grey u-pt20 u-mt20 u-mb20">
    <div class="buttons u-mt20">
      <div class="row">
        <div class="col-md-9 order-md-2 order-1">
          <button
            type="button"
            class="btn btn--primary modal__trigger"
            (click)="onModifyDates()  "
            [attr.disabled]="documentFormArray.invalid ? true : null "
          >
            Guardar cambios en documentos
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
